// src/components/ProcessamentoCard.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEye } from 'react-icons/fa';
import './ProcessamentoCard.css';

const ProcessamentoCard = ({ processo }) => {
  const navigate = useNavigate();

  const getStatusClass = (status) => {
    switch (status) {
      case 'CONCLUIDO':
        return 'status-concluido';
      case 'EM_PROCESSAMENTO':
        return 'status-em-processamento';
      case 'ERRO':
        return 'status-erro';
      default:
        return '';
    }
  };

  return (
    <div className="processamento-card" onClick={() => navigate(`/processamentos/${processo.id}`)}>
      <div className="card-header">
        <h3>Processamento #{processo.id}</h3>
        <span className={`status-badge ${getStatusClass(processo.status)}`}>{processo.status}</span>
      </div>
      <div className="card-body">
        <p><strong>Tipo:</strong> {processo.tipo_processamento}</p>
        <p><strong>Usuário:</strong> {processo.usuario_cadastro}</p>
        <p><strong>Início:</strong> {new Date(processo.created_at).toLocaleString()}</p>
        <p><strong>Fim:</strong> {processo.data_fim ? new Date(processo.data_fim).toLocaleString() : '-'}</p>
      </div>
      <div className="card-footer">
        <button
          className="icon-button"
          title="Detalhes"
        >
          <FaEye /> Ver Detalhes
        </button>
      </div>
    </div>
  );
};

export default ProcessamentoCard;
